import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=1d701cae&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=ts"
export * from "./Portal.vue?vue&type=script&lang=ts"
import style0 from "./Portal.vue?vue&type=style&index=0&id=1d701cae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d701cae",
  null
  
)

export default component.exports